import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '480px',

  },
  titleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: '18px',
    color: theme.palette.grey.grey700,
    fontWeight: 600,
    marginTop: '13.5px',
    marginBottom: '15px'
  },
  searchText: {
    fontSize: '12px',
    color: theme.palette.grey.grey700,
    marginBottom: '9px',
  },
  tpResultWrapper: {
    marginTop: '10px',
    maxHeight: '200px',
    overflowY: 'auto',
    boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.07)',
    '> :nth-child(odd)': {
      background: theme.palette.primary.primary100
    }
  },
  tpResult:  {
    display: 'flex',
    alignItems: 'center',
    height: '51px',
    padding: '3px 10px'
  },
  tpResultInfos: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  tpName: {
    color: theme.palette.primary.primary500,
    fontSize: '16px',
    fontWeight: 600,
    maxWidth: '250px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  tpActivity: {
    fontSize: '10px',
    color: theme.palette.grey.grey700,
    fontWeight: 700,
    maxWidth: '250px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  noResults: {
    fontSize: '12px',
    color: theme.palette.grey.grey700,
    textAlign: 'center',
  }
}));

export default useStyles;
